<template>
	<div class="dashboard-container">
		<div class="waititle">
			<div class="blue" />
			商品数据概括
		</div>
		<div class="showlist_top">
			<div v-for="i in 4" :key="i" class="showlist_top1">
				<div>累计会员数</div>
				<div>50000</div>
				<div class="bili">
					<div>
						周同比
						<img src="../../assets/shangsheng.png" />
						<span style="color: #4B4B4B;">100%</span>
					</div>
				</div>
			</div>
		</div>
		<div class="showlist2s">
			<div class="showlist2">
				<div class="waititle">
					<div class="blue" />
					新老客户交易构成
				</div>
				<div class="attributes">
					<div class="attributes_title">
						<el-select size="small" v-model="user" style="width: 110px;margin-right:10px;"
							placeholder="请选择">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value" />
						</el-select>
						<el-date-picker size="small" v-model="data" type="date" style="margin-right:10px;"
							placeholder="选择日期" />
						<el-button type="primary" size="small">导出</el-button>
					</div>
				</div>
				<div class="attributes_bottom">
					<div class="newo">
						<!--  -->
						<div class="newo2">
							<div class="new2_table">
								<div class="table_title">
									取号订单数TOP5服务
								</div>
								<el-table :data="tableData" border :cell-style="{'text-align':'center'}"
									:header-cell-style="{'text-align':'center'}">
									<el-table-column prop="date" label="TOP" />
									<el-table-column prop="name" label="服务名称" />
									<el-table-column prop="address" label="订单数" />
								</el-table>
							</div>
						</div>
						<div class="newo2">
							<div class="new2_table">
								<div class="table_title">
									好评最高TOP5服务
								</div>
								<el-table :data="tableData" border :cell-style="{'text-align':'center'}"
									:header-cell-style="{'text-align':'center'}">
									<el-table-column prop="date" label="TOP" />
									<el-table-column prop="name" label="服务名称" />
									<el-table-column prop="address" label="订单数" />
								</el-table>
							</div>
						</div>
						<div class="newo2">
							<div class="new2_table">
								<div class="table_title">
									取号订单数TOP5服务
								</div>
								<el-table :data="tableData" border :cell-style="{'text-align':'center'}"
									:header-cell-style="{'text-align':'center'}">
									<el-table-column prop="date" label="TOP" />
									<el-table-column prop="name" label="服务名称" />
									<el-table-column prop="address" label="订单数" />
								</el-table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="showlist2s">
			<div class="showlist2">
				<div class="waititle">
					<div class="blue" />
					商品排行
				</div>
				<div class="attributes">
					<div class="attributes_title">
						<el-select size="small" v-model="user" style="width: 110px;margin-right:10px;"
							placeholder="请选择">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value" />
						</el-select>
						<el-date-picker size="small" v-model="data" type="date" style="margin-right:10px;"
							placeholder="选择日期" />
						<el-button type="primary" size="small">导出</el-button>
					</div>
				</div>
				<div class="attributes_bottom">
					<div class="newo">
						<div class="newo2 news2biao">
							<div class="con1_tu">
								<div class="con1_biao">
									<ve-ring height="320px" style="position: relative;top: -50px;"
										:data="chartData_huan" :legend-visible="false" />
								</div>
							</div>
						</div>
						<div class="newo2">
							<div class="table_title2">
								访客榜TOP5商品
							</div>
							<div class="new2_table">
								<el-table :data="tableData" border :cell-style="{'text-align':'center'}"
									:header-cell-style="{background:'#F7F7F7','text-align':'center'}">
									<el-table-column prop="date" label="TOP" />
									<el-table-column prop="name" label="服务名称" />
									<el-table-column prop="address" label="订单数" />
								</el-table>
							</div>
						</div>
						<div class="newo2">
							<div class="table_title2">
								支付订单数TOP5服务
							</div>
							<div class="new2_table">
								<el-table :data="tableData" border :cell-style="{'text-align':'center'}"
									:header-cell-style="{background:'#F7F7F7','text-align':'center'}">
									<el-table-column prop="date" label="TOP" />
									<el-table-column prop="name" label="服务名称" />
									<el-table-column prop="address" label="订单数" />
								</el-table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				chartData_huan: {
					columns: ['日期', '访问用户'],
					rows: [{
						日期: '会员',
						访问用户: 1393
					}, {
						日期: '用户',
						访问用户: 3530
					}, ]
				},
				tableData: [{
					date: '1',
					name: '剪发',
					address: '1234'
				}, {
					date: '2',
					name: '剪发',
					address: '13242'
				}, {
					date: '3',
					name: '剪发',
					address: '123'
				}, {
					date: '/',
					name: '/',
					address: '/'
				}, {
					date: '/',
					name: '/',
					address: '/'
				}],
				user: '',
				listtime: '',
				data: '',
				activeName: 'two',
				friendsnum: [{
					name: '累计会员数'
				}],
				options: [{
					value: '选项1',
					label: '黄金糕'
				}, {
					value: '选项2',
					label: '双皮奶'
				}, {
					value: '选项3',
					label: '蚵仔煎'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				option2: [{
					value: '选项1',
					label: '今天'
				}, {
					value: '选项2',
					label: '明天'
				}, {
					value: '选项3',
					label: '后天'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
			}
		},
		mounted() {},
		methods: {
			handleClick(tab, event) {
				console.log(tab, event)
			}
		}
	}
</script>

<style scoped="scoped" lang="less">
	.table_title {
		width: 100%;
		height: 2.625rem;
		background-color: #F2F2F2;
		color: #9C9C9C;
		text-align: center;
		line-height: 2.625rem;
	}

	.table_title2 {
		width: 95%;
		height: 2.625rem;
		background-color: #F2F2F2;
		color: #9C9C9C;
		text-align: center;
		line-height: 2.625rem;
	}

	.waititle {
		display: flex;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #3e3e3e;

		.blue {
			width: 5px;
			position: relative;
			top: 3px;
			height: 15px;
			background: #409eff;
			border-radius: 2px;
			margin-right: 10px;
			margin-bottom: 20px;
		}
	}

	.dashboard-container {
		box-sizing: border-box;

		.showlist_top {
			width: 100%;
			height: 145px;
			display: flex;

			.showlist_top1 {
				box-sizing: border-box;
				padding: 20px;
				flex: 1;
				margin-left: 20px;
				background: #f2f2f2;
				border-radius: 6px;

				>div {
					&:nth-child(1) {
						font-size: 14px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #3e3e3e;
					}

					&:nth-child(2) {
						font-size: 20px;
						margin-top: 10px;
						font-size: 36px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #3e3e3e;
					}
				}

				.bili {
					margin-top: 10px;
					display: flex;
					font-size: 14px;

					img {
						width: 10px;
						height: 15px;
						position: relative;
						top: 2px;
					}
				}

				&:nth-child(1) {
					margin: 0;
				}
			}
		}

		.showlist2s {
			width: 100%;
			padding: 4px;
			box-sizing: border-box;
		}

		.showlist2 {
			padding: 20px;
			box-sizing: border-box;
			margin-top: 20px;
			width: 100%;
			background: #ffffff;
			box-shadow: 0px 2px 9px 0px rgba(#0000, 0.09);

			.attributes_bottom {
				margin-top: -10px;
			}
		}
	}

	.newo {
		display: flex;
		width: 100%;
	}


	.news2biao {
		height: 280px;
		overflow: hidden;
	}

	.newo2 {
		flex: 3.5;
		margin-top: 50px;

		.con1_tu {
			width: 100%;
			overflow: hidden;
			display: flex;

			>div:nth-child(1) {
				flex: 1;
			}

		}
	}

	.new2_table {
		box-sizing: border-box;
		margin-right: 20px;
	}
</style>